module.exports = __webpack_public_path__ + "static/media/YB5F17_3.c33d492d.jpg";